export default "/_next/static/images/carousel-right-arrow-legacy-de900f74435190ef21e3169dcb978081.svg";